import { DropdownComponent } from 'components/SignupProfileComponents/Dropdown';
import { RadioComponent } from 'components/SignupProfileComponents/Radio';
import { TextBoxComponent } from 'components/SignupProfileComponents/Textbox';
import { useEffect, useReducer, useState } from 'react';
import useAxiosFetch from 'hooks/useAxiosFetch';
import { apiBackendBaseUrl } from 'utils/envsetup';
import './styles.scss';
import axios from 'utils/axiosInstance';
import axiosInstance from 'utils/axiosInstance';
import { useSelector } from 'react-redux';
import useAxiosFunction from 'hooks/useAxiosFunction';
import Image from 'react-bootstrap/Image';
import keycloak from 'Keycloak';
import { Route, Routes, Navigate, useNavigate } from 'react-router-dom/dist';
import CircularProgress from '@mui/material/CircularProgress';
let data = [];

const validate = (key, value) => {
  if (key === 'mobileNumber') {
    const regex = /^\d{10}$/.test(value);
    // debugger
    return regex;
  } else {
    return true;
  }
};

const reducer = (state, { type, payload }) => {
  switch (type) {
    case 'ON_CHANGE': {
      return {
        ...state,
        [payload.name]: {
          value: payload.value,
          isValid: !payload?.required
            ? true
            : payload?.value
            ? validate(payload.questionKey, payload.value)
            : false,
        },
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default function UserProfile(params) {
  const userProfile = useSelector(state => state.commonData.userProfile);
  const tenant = useSelector(state => state.commonData.tenant);
  const [isLoading, setIsLoading] = useState(false);
  const [signupImageUrl, setSignupImageUrl] = useState(
    process.env.REACT_APP_SIGNUP_IMAGES_BASE_URL_PATH +
      (userProfile?.utmId && userProfile?.utmId !== null
        ? userProfile?.utmId + '.webp'
        : 'default.webp'),
  );
  const setImage = () => {
    //console.log('signupImageUrl', signupImageUrl);
    setSignupImageUrl(process.env.REACT_APP_SIGNUP_IMAGES_BASE_URL_PATH + 'default.webp');
  };
  const navigate = useNavigate();
  //   console.log('userProfile.utmCampaign :>> ', userProfile);
  const [response, error, loading, axiosFetch] = useAxiosFunction({
    isDispatch: false,
  });
  const loaderContainerStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  };

  useEffect(() => {
    const newHeaders = {
      // updated headers
      Authorization: `Bearer ${keycloak.token}`,
      // any other headers you want to update
    };

    // Update the headers in the axios instance
    axiosInstance.defaults.headers = {
      ...axiosInstance.defaults.headers, // Keep existing headers
      ...newHeaders, // Add new headers
    };
    if (userProfile !== null) {
      const reqBody = {
        campaignName:
          userProfile?.ctaId &&
          (userProfile.ctaId === 'pricingpage-onlinebusiness' ||
            userProfile.ctaId === 'pricingpage-serviceprovider')
            ? userProfile.ctaId
            : userProfile?.utmContent ?? 'default',
        // campaignName: 'pricingpage-onlinebusiness',
      };
      axiosFetch({
        axiosInstance: axios,
        method: 'POST',
        url: apiBackendBaseUrl + process.env.REACT_APP_IAM_USER_PROFILE_QUESTIONS,
        requestConfig: reqBody,
      }).then(response => {
        data = response;
        data.forEach(r => {
          dispatch({
            type: 'ON_CHANGE',
            payload: { name: r.id, value: '', questionKey: r.questionKey, required: r.required },
          });
        });
      });
    }
  }, []);

  const [state, dispatch] = useReducer(reducer, {});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const onFieldChange = (name, value, questionKey, required) => {
    dispatch({ type: 'ON_CHANGE', payload: { name, value, questionKey, required } });
  };
  const renderCondition = question => {
    if (question.optionDisplayType === 'textbox') {
      const props = {
        initialValue: '',
        name: question.id,
        onChange: onFieldChange,
        required: question.required,
        questionKey: question.questionKey,
        isValid: isFormSubmitted ? !!state[question.id]?.isValid : true,
        placeHolder: question.placeHolder,
        message:
          question.questionKey === 'mobileNumber' ? 'Enter a valid mobile number' : undefined,
      };
      return <TextBoxComponent {...props} />;
    } else {
      if (question.optionDisplayType === 'dropdown') {
        const props = {
          initialValue: '',
          name: question.id,
          onChange: onFieldChange,
          options: question.options,
          required: question.required,
          questionKey: question.questionKey,
          isValid: isFormSubmitted ? !!state[question.id]?.isValid : true,
        };
        return <DropdownComponent {...props} />;
      } else if (question.optionDisplayType === 'Radio') {
        const props = {
          initialValue: '',
          name: question.id,
          onChange: onFieldChange,
          options: question.options,
          required: question.required,
          questionKey: question.questionKey,
          isValid: isFormSubmitted ? !!state[question.id]?.isValid : true,
        };
        return <RadioComponent {...props} />;
      }
    }
  };
  const renderFields = questions => {
    return questions?.map(question => {
      return question.display ? (
        <div key={question.id}>
          <label className={`form-field-label ${question.required ? 'field-required' : ''}`}>
            {question.question}
          </label>
          {renderCondition(question)}
        </div>
      ) : (
        <></>
      );
    });
  };
  const submitForm = e => {
    setIsLoading(true);
    e.preventDefault();
    setIsFormSubmitted(true);
    let isFormValid = false;
    let formFields = Object.keys(state);
    if (data?.length === formFields?.length) {
      for (let key of formFields) {
        if (!state[key].isValid) {
          isFormValid = false;
          break;
        } else {
          isFormValid = true;
        }
      }
    }
    if (isFormValid) {
      const payload = {};
      for (let key of Object.keys(state)) {
        payload[key] = state[key].value;
      }
      payload['userId'] = userProfile.userId;
      const reqBody = payload;

      axiosFetch({
        axiosInstance: axios,
        method: 'POST',
        url: apiBackendBaseUrl + process.env.REACT_APP_IAM_SAVE_USER_PROFILE_ANSWERS,
        requestConfig: reqBody,
      }).then(response => {
        if (response.emailVerified === true) {
          window.location.href = '/workspace';
          setIsLoading(false);
        } else {
          keycloak.login();
        }
      });
    } else {
      setIsLoading(false);
    }
  };
  //if(tenant?.profileQuestionsRequired!==null && tenant?.profileQuestionsRequired!==undefined&&tenant?.profileQuestionsRequired)
  return (
    <div className="user-profile">
      {isLoading ? (
        <div style={loaderContainerStyle}>
          <CircularProgress sx={{ color: 'blue' }} />
        </div>
      ) : null}
      <div className="bgdiv" style={{ backgroundColor: '#14033A', paddingBottom: '30px' }}>
        <div className="maxwidthprops">
          {/* <div style={{ color: '#FFFFFFF2' }} className="campaign-text">
            Fastest, Easiest, End-to-End platform to Launch your Digital Product
          </div>
          <div className="studio-text">Open Weaver Studio - the No Code for Digital Products</div> */}
          <div className="imagecontrl">
            {/* <Image src="/images/campaign.webp" style={{ maxWidth: '100%', height: 'auto' }}></Image> */}
            <Image
              src={signupImageUrl}
              style={{ maxWidth: '100%', height: 'auto' }}
              onError={setImage}
            ></Image>
          </div>
        </div>
      </div>
      <div className="formdiv">
        <div className="page-header">
          <Image src="/svg/kandilogo.svg" />
        </div>
        <div className="page-body">
          <div className="user-profile-form">
            <div className="form-title">Personalize Studio</div>
            <div className="form-group">{renderFields(data)}</div>
            <div className="submit-form mt-10">
              <button onClick={submitForm}>Start</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
